<template>
  <BaseDialog
    title="預約扣堂票設定"
    width="610px"
    :close-on-click-modal="false"
    :btn1-loading="loading"
    @cancel="$emit('close')"
    @close="$emit('close')"
    @confirm="onSubmit"
  >
    <BaseElForm ref="formRef" :model="formData" label-position="top">
      <BaseElFormItem label="是否開啟預約扣堂票">
        <BaseElSwitch
          v-model="formData.enableClassTicket"
          active-text="開啟"
          inactive-text="關閉"
        />
      </BaseElFormItem>
    </BaseElForm>
  </BaseDialog>
</template>

<script>
import { defineComponent, onBeforeMount } from 'vue'
import { useBaseForm } from '@/use/useForm'
import { UpdateReservationParameter } from '@/api/reservation'
import { useShop } from '@/use/shop'
import notifyMessage from '@/config/notifyMessage'
import { pageStyleList } from '@/config/reservation'
import BaseDialog from '@/components/Dialog/BaseDialog.vue'

export default defineComponent({
  name: 'EditReservationThemeModal',
  components: { BaseDialog },
  props: {
    configData: { type: Object, default: () => ({}) },
  },
  setup (props, { emit }) {
    const { formRef, formData, initFormData, loading, checkForm } = useBaseForm()
    const { shopId } = useShop()

    const onSubmit = async () => {
      if (loading.value) return
      loading.value = true
      if (!(await checkForm(formRef.value))) return
      const [, err] = await UpdateReservationParameter({
        shopId: shopId.value,
        enableClassTicket: formData.enableClassTicket,
      })
      loading.value = false
      if (err) {
        window.$message.error(err)
        return
      }

      window.$message.success(notifyMessage.updateSuccess)
      emit('close')
      emit('refresh')
    }

    onBeforeMount(() => {
      initFormData({
        enableClassTicket: props.configData.enableClassTicket,
      })
    })
    return { formRef, formData, loading, onSubmit, pageStyleList }
  },
})
</script>

<style lang="postcss" scoped></style>
